import React from 'react';
import Table from 'react-bootstrap/Table';

import Const from '../../util/Constants';
import Display from '../../util/Display';

import './ProjectPreview.css';

class PropertyInformation extends React.Component {

  constructor(props) {
    super(props);
    this.setProjectInfo(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.lead && props.project.id !== this.id ) {
      this.setProjectInfo(props);
    }
  }

  setProjectInfo = props => {
    var fields = props.model.fields;
    const keys = Object.keys(fields);
    this.fields = []
    for(let j = 0; j < keys.length; j++) {
      if(keys[j] === 'status' || keys[j] === 'phone' || keys[j] === 'email'
        || fields[keys[j]].status === Const.Trash) {
        continue;
      }
      if(fields[keys[j]].visible === Const.True) {
        const field = fields[keys[j]];
        field.key = keys[j];
        this.fields.push(field);
      }
    }
    this.fields = this.fields.sort((field1, field2) => field1.order - field2.order);
    fields = this.fields;
    let count = Math.floor((fields.length + 1) / 3);
    this.fields1 = [];
    let i = 0;
    for(; i < count; i++ ) {
      const value = Display.FieldValue(props.project, fields[i].key, props.model.fields);
      this.fields1.push(
        <tr key={`d_f_${fields[i].key}`}>
          <th scope="row">{fields[i].label_name}</th>
          <td>{value}</td>
        </tr>
      );
    }
    if(this.fields1.length === 0) this.fields1 = <tr><th colSpan="2">No Records</th></tr>;

    this.fields2 = [];
    let len = count * 2;
    for(; i < len; i++ ) {
      const value = Display.FieldValue(props.project, fields[i].key, props.model.fields);
      this.fields2.push(
        <tr key={`d_f_${fields[i].key}`}>
          <th scope="row">{fields[i].label_name}</th>
          <td>{value}</td>
        </tr>
      );
    }
    if(this.fields2.length === 0) this.fields2 = <tr><th colSpan="2">No Records</th></tr>;

    this.fields3 = [];
    for(; i < fields.length; i++ ) {
      const value = Display.FieldValue(props.project, fields[i].key, props.model.fields);
      this.fields3.push(
        <tr key={`d_f_${fields[i].key}`}>
          <th scope="row">{fields[i].label_name}</th>
          <td>{value}</td>
        </tr>
      );
    }
    if(this.fields3.length === 0) this.fields3 = <tr><th colSpan="2">No Records</th></tr>;
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="formhead"><h2>Project Information</h2></div>
        </div>
        <div className="col-md-4">
          <Table striped bordered hover> <tbody> {this.fields1} </tbody> </Table>
        </div>
        <div className="col-md-4">
          <Table striped bordered hover> <tbody> {this.fields2} </tbody> </Table>
        </div>
        <div className="col-md-4">
          <Table striped bordered hover> <tbody> {this.fields3} </tbody> </Table>
        </div>
      </div>                     
    );
  }
}

export default PropertyInformation;